module.exports = __webpack_public_path__ + "static/media/mern.16648add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/mern.jpg
// module id = 152
// module chunks = 0